import styled from 'styled-components';

export const BkngOptionsOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        border-top: 1px dashed ${props.theme.colors.grey.lighte7};
        padding-top: ${props.theme.spacing.large.l15};
        position: relative;
    `
);

export const LeftHalfCircle = styled.div(
    props => `
        width:1.6rem;
        height: 1.6rem;
        border-radius: ${props.theme.misc.borderRadius.round};
        background-color: ${props.theme.colors.grey.lightf2};
        position: absolute;
        left:-3.2rem;
        top:-.8rem;
        z-index: 1;
    `
);

export const RightHalfCircle = styled.div(
    props => `
        width:1.6rem;
        height: 1.6rem;
        border-radius: ${props.theme.misc.borderRadius.round};
        background-color: ${props.theme.colors.grey.lightf2};
        position: absolute;
        right:-3.2rem;
        top:-.8rem;
        z-index: 1;
    `
);

export const BkngOptionInnerWrap = styled.div(
    props => `
        // width:100%;
        display: flex;
        align-items: center;
        cursor: pointer;
        padding-right: 1rem;
    `
);

export const BkngOptionWrap = styled.div(
    props => `
        // width:25%;
        display: flex;
        align-items: center;
    `
);

export const BkngOptionIconWrap = styled.div(
    props => `
        width:3.2rem;
        height: 3.2rem;
        // border-radius: ${props.theme.misc.borderRadius.round};
        align-items: center;
        justify-content: center;
        display: flex;
        // background-color: ${props.theme.colors.blue.lighted};
    `
);

export const BkngOptionText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        // padding-left: ${props.theme.spacing.base};
    `
);